import { object, ObjectSchema, string } from 'yup';

import { CustomerFlagDto, CustomerStatusDto } from '@/api/generated';
import {
  selectSearchOptionRequiredFieldsValidation,
  selectSearchOptionRequiredValidation,
} from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { CreateIndividualCustomerFormModel } from '@/views/customers/createIndividual/model/CreateIndividualCustomerForm.model.ts';

export const useCreateIndividualCustomerFormValidation =
  (): ObjectSchema<CreateIndividualCustomerFormModel> => {
    const { t } = useTranslationWithPrefix('validation');

    return object().shape({
      community: string().nullable(),
      county: string().nullable(),
      distinguishingLabel: string().optional(),
      flag: selectSearchOptionRequiredValidation<CustomerFlagDto>(string(), t),
      flatNo: string().nullable(),
      houseNo: string().nullable(),
      locality: string().nullable(),
      name: string().required(t('general.required')),
      nip: string().optional(),
      postCode: string().nullable(),
      province: string().nullable(),
      // hidden from creators without CUSTOMER_APPROVE, so the backend creates a Prospekt
      status: selectSearchOptionRequiredFieldsValidation<CustomerStatusDto>(string(), t).nullable(),
      street: string().nullable(),
    });
  };
